import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import agreementPropTypes from '../../agreementPropTypes';
import partnerPropTypes from '../../partnerPropTypes';
import { formatDate } from '../../getDeadline.js';

class RespondToAgreementSent extends PureComponent {
    constructor() {
        super();
        this.state = {
            submitted: false,
            termsAccepted: false,
        };

        this.handleClickAcceptTerms = this.handleClickAcceptTerms.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReject = this.handleReject.bind(this);
    }

    handleClickAcceptTerms() {
        this.setState({
            termsAccepted: !this.state.termsAccepted,
        });
    }

    handleSubmit() {
        const { handleClickAccept } = this.props;
        this.setState({
            submitted: true,
        });

        if (this.isValid()) {
            handleClickAccept();
        }
    }

    handleReject() {
        this.props.handleClickReject();
    }

    isValid() {
        return this.state.termsAccepted;
    }

    showInvalid() {
        return this.state.submitted && !this.isValid();
    }

    render() {
        const { agreement, partner } = this.props;

        return (
            <div>
                <p>
                    Er du og {partner.name} enige om denne avtalen? Du må svare
                    innen
                    <span className="strong">
                        {' '}
                        {formatDate(agreement.data.acceptDeadline)}
                    </span>.
                </p>

                <div
                    className={classNames('formelement mvl', {
                        invalid: this.showInvalid(),
                    })}
                >
                    <div className="input">
                        <div className="fancyinput">
                            <input
                                id="accept-terms"
                                type="checkbox"
                                required
                                onClick={this.handleClickAcceptTerms}
                            />
                            <label htmlFor="accept-terms">
                                Jeg forstår at avtalen er bindende.
                            </label>
                            {this.showInvalid() && (
                                <span className="help-inline">
                                    Du må bekrefte at du forstår at avtalen er
                                    bindende.
                                </span>
                            )}
                        </div>
                    </div>
                </div>

                <div className="r-pal">
                    <div className="r-mbm">
                        <button
                            className={classNames('primary fullwidth', {
                                inprogress: agreement.loading,
                            })}
                            disabled={agreement.loading}
                            onClick={this.handleSubmit}
                        >
                            Godkjenn
                        </button>
                    </div>

                    <div>
                        <button
                            className="r-size1of2 fullwidth"
                            disabled={agreement.loading}
                            onClick={this.handleReject}
                        >
                            Avslå
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

RespondToAgreementSent.propTypes = {
    agreement: agreementPropTypes.isRequired,
    handleClickAccept: PropTypes.func.isRequired,
    handleClickReject: PropTypes.func.isRequired,
    partner: partnerPropTypes.isRequired,
};

export default RespondToAgreementSent;



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/respondToAgreementSent.jsx